import { createSelector } from "reselect"
import { find, last } from "lodash"
import { computeData } from "modules/analyze-composition/selectors/data"
import { getConcentrationData } from "modules/analyze-composition/selectors/concentration"
import { DATABASE_DATE_FORMAT } from "helpers/formatters/dates"
import { getSelectedContributorCategoryId } from "helpers/compositeSecuritiesDetails"

const getAllCategoryItems = (_, props) => props.allCategoryItems
const getSelectedDate = (_, props) => props.selectedDate

const getContributorData = createSelector(
  [getAllCategoryItems, getConcentrationData],
  (items, concentration) => computeData(items, concentration),
)

const getLastContributor = createSelector(
  [getContributorData],
  (data) => last(data),
)

// This is to jump straight to the contributors drilldown
export const getSelectedContributorCategory = createSelector(
  [getSelectedContributorCategoryId, getAllCategoryItems],
  (selected, items) => find(items, ({ id }) => id === "maxConcentration"),
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format(DATABASE_DATE_FORMAT)) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format(DATABASE_DATE_FORMAT))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return items
      .map(item => ({
        label: item.label,
        id: item.id,
        value: dayData[item.id],
        color: item.color,
        category: item.category,
        favorite: item.favorite,
        field: item.field,
      }))
      .filter(item => item.value || item.favorite)
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  (contributors, selected) => {
    if (!selected) {
      return 0
    }

    const item = find(contributors, d => d.id === selected.id)
    if (item) {
      return item.value
    }
    return 0
  },
)
